import { z } from "zod";
import { getIdSchema, ID, makeIdGenerator } from "../utils";
import { hiveIdSchema } from "./hiveSchema";
import { scaleIdSchema } from "./scaleSchema";

export const scaleAssignmentIdPrefix = "hsa_";
export type ScaleAssignmentId = ID<typeof scaleAssignmentIdPrefix>;
export const generateScaleAssignmentId = makeIdGenerator(
  scaleAssignmentIdPrefix,
);
export const scaleAssignmentIdSchema = getIdSchema(
  scaleAssignmentIdPrefix,
  "ScaleAssignmentId",
);

export const scaleAssignmentSchema = z
  .object({
    id: scaleAssignmentIdSchema,
    hiveId: hiveIdSchema,
    scaleId: scaleIdSchema,
    assignedAt: z.coerce.date(),
    unassignedAt: z.coerce.date().nullable(),
  })
  .meta({ id: "ScaleAssignment" });

export type ScaleAssignment = z.infer<typeof scaleAssignmentSchema>;

export const putAssignmentSchema = z
  .object({
    hiveId: hiveIdSchema,
    scaleId: scaleIdSchema,
    assignedAt: z.coerce.date(),
    unassignedAt: z.coerce.date().nullable().optional(),
  })
  .meta({ id: "ScaleAssignmentUpdate" });
export type PutAssignment = z.infer<typeof putAssignmentSchema>;
